VLW.form = class extends VLW.classBase {
	constructor(el) {
		super(el);
		this.events    = {onSubmit: new signals.Signal()};
		this.inputs    = this.elt.querySelectorAll("input[type=hidden],input[type=text],input[type=password],input[type=email],textarea");
		this.selects   = this.elt.querySelectorAll("select");
		this.name      = this.elt.getAttribute("name");
		this.submitBtn = this.elt.querySelector("[type=submit]");
		this.elt.addEventListener("submit", this.onSubmit);
		this.initInput();
	}

	initSelect() {
		[...this.selects].forEach((elt)=> new VLW.CustomSelect(elt));
	}
	onSubmit(e) {
		e.preventDefault();
		this.isValid();
		return false;
	}

	raz() {
		[...this.inputs].forEach((elt)=> elt.value ='');
	}

	initInput() {
		[...this.inputs].forEach((elt)=> {
			if (!elt.txtDefaut) {
				elt.txtDefaut = elt.getAttribute("placeholder");
				elt.txtDefaut = (elt.hasAttribute("data-required")) ? elt.txtDefaut + " *" : elt.txtDefaut;
				elt.addEventListener("focus", this.onFocusInputs);
				(Modernizr.placeholder !== true && elt.addEventListener("blur", this.onBlurInputs));
			}
		});
	}
	onBlurInputs(e) {

	}
	onFocusInputs(e) {
		e.currentTarget.classList.remove('error');
	}

	action(){
		return  this.elt.getAttribute("action");
	}

	data() {
		let data={};
		this.inputs.forEach((elt) => {

			data[elt.getAttribute("name")] = elt.value;
		});
		this.selects.forEach((elt) => {
			data[elt.getAttribute("name")] = elt.value;
		});

		return data;
	}


	isValid(displayError) {
		displayError    = (typeof(displayError) === "undefined") ? true : displayError;
		this.dataToSend = {};
		this.oData      = {};
		let sendData    = true;
		for (let i = 0, j = this.inputs.length; i < j; i++) {
			let name         = this.inputs[i].getAttribute("name");
			let isLikeDefaut = this.inputs[i].value === this.inputs[i].txtDefaut;
			let isEmpty      = this.inputs[i].value === '';
			let isRequired   = (this.inputs[i].getAttribute("data-required") && this.inputs[i].getAttribute("data-required") === "true");
			let isSameas     = (this.inputs[i].hasAttribute("data-sameas"));
			if ((isLikeDefaut === true || isEmpty === true) && isRequired === true) {
				sendData = false;
				if (displayError !== false) {
					this.inputs[i].classList.add("error");
				}
			}

			if (isSameas) {
				try {
					var same = this.elt.querySelector("[id='" + this.inputs[i].getAttribute("data-sameas") + "']");
					if (!(same && same.value === this.inputs[i].value)) {
						sendData = false;
						this.inputs[i].classList.add("error");
					}
				} catch (e) {
					sendData = false;
					this.inputs[i].classList.add("error");
				}
			}

			if (!isLikeDefaut && !isEmpty) {
				let value = this.inputs[i].value;
				let type  = this.inputs[i].getAttribute("data-type");
				if (type === "email") {
					let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					if (!re.test(value)) {
						sendData = false;
						if (displayError !== false) {
							this.inputs[i].classList.add("error");
						}
					}
				}
				this.oData[name] = value;
			}
		}
		for (let i = 0, j = this.selects.length; i < j; i++) {
			let name                                 = this.selects[i].getAttribute("name");
			this.oData[name]                         = this.selects[i].value;
			this.oData[name.replace("]", "_label]")] = this.selects[i].options[this.selects[i].selectedIndex].innerText;
		}
		if (sendData === true) {
			this.events.onSubmit.dispatch({data: this.oData, form: this.elt});
			return true;
		} else {
			return false;
		}
	}

	instanceClean() {
		this.elt.removeEventListener("submit", this.onSubmit);
		for (let i = 0, j = this.inputs.length; i < j; i++) {
			this.inputs[i].removeEventListener("focus", this.onFocusInputs);
			this.inputs[i].removeEventListener("blur", this.onBlurInputs);
		}
		super.instanceClean();
	}
}